import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';
import Welcome from './Welcome';

const Dashboard = () => {
    return (
        <Card>
            <CardContent>
                <Welcome />
                <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
                    Admin Dashboard
                </Typography>
                <Typography variant="body1" color="text.secondary">
                    Welcome to the KivoAI Admin Panel. Use the menu on the left to manage users.
                </Typography>
            </CardContent>
        </Card>
    );
};

export default Dashboard;
